// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalePromo_modalOverlay__zboVX","modalContent":"ModalePromo_modalContent__5JATd","closeButton":"ModalePromo_closeButton__pdlbd","cta":"ModalePromo_cta__IYOW+"};